import classnames from 'classnames';
import React from 'react';
import { Div } from '@dnb/eufemia';
import styles from './Content.module.scss';

interface Props {
  children: React.ReactNode;
  narrow: boolean;
}

const Content = ({ narrow, children }: Props) => {
  const classname = classnames(styles.container, {
    [styles.narrow]: narrow,
  });

  return (
    <Div data-testid="content" className={styles.content}>
      <Div
        data-testid={`container-${narrow ? 'narrow' : 'wide'}`}
        className={classname}
      >
        {children}
      </Div>
    </Div>
  );
};

export default Content;
